document.addEventListener( "DOMContentLoaded", function () {
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll( '[data-bs-toggle="popover"]' ),
  );
  var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
    return new bootstrap.Popover( popoverTriggerEl );
  } );

  if ( document.querySelectorAll( ".tier-benefits-main .nav-item" ).length === 1 ) {
    document.querySelector( ".nav-inner" ).classList.add( "single-nav-item" );
    document.querySelectorAll( ".benefit-container .benefit-line" ).forEach( function ( benefitLine ) {
      benefitLine.classList.add( "single-benefit-line" );
      document.querySelector( ".tier-benefits-main .nav-tabs" ).classList.add( "single-benefit-nav" );
    } );
  }

  //remove empty benefit lines
  var desktopBenefitLines = document.querySelectorAll( ".desktop-benefit-line" );
  desktopBenefitLines.forEach( function ( desktopBenefitLine ) {
    var allEmpty = true;
    var desktopBenefitsValue = desktopBenefitLine.querySelectorAll(
      ".desktop-benefit-value",
    );
    desktopBenefitsValue.forEach( function ( desktopBenefitValue ) {
      if ( desktopBenefitValue.innerHTML.trim() !== "" ) {
        allEmpty = false;
      }
    } );
    if ( allEmpty ) {
      desktopBenefitLine.remove();
    }
  } );

  var filterBenefits = document.querySelectorAll( ".filter-benefits" );
  filterBenefits.forEach( function ( filterBenefit ) {
    filterBenefit.addEventListener( "click", function () {
      var filterValue = this.getAttribute( "data-attribute" );

      if ( filterValue === "all" ) {
        //remove active from other filters
        filterBenefits.forEach( function ( filterBenefit ) {
          filterBenefit.classList.remove( "active-filter" );
        } );
        //add active to 'all' filter
        document
          .querySelector( '[data-attribute="all"]' )
          .classList.add( "active-filter" );
      } else {
        if ( this.classList.contains( "active-filter" ) ) {
          this.classList.remove( "active-filter" );
        } else {
          this.classList.add( "active-filter" );
        }
        document
          .querySelector( '[data-attribute="all"]' )
          .classList.remove( "active-filter" );

        //if all filters are active, add active to 'all' filter and remove active from others
        var allFilters = document.querySelectorAll( ".filter-benefits" );
        var activeFilters = document.querySelectorAll( ".active-filter" );
        if ( allFilters.length - 1 === activeFilters.length ) {
          filterBenefits.forEach( function ( filterBenefit ) {
            filterBenefit.classList.remove( "active-filter" );
          } );
          document
            .querySelector( '[data-attribute="all"]' )
            .classList.add( "active-filter" );
        }
        //if no filters are active, add active to 'all' filter
        if ( activeFilters.length === 0 ) {
          document
            .querySelector( '[data-attribute="all"]' )
            .classList.add( "active-filter" );
        }
      }

      //get list of benefits based on active filters
      var activeFilters = document.querySelectorAll( ".active-filter" );
      var benefits = document.querySelectorAll( ".benefits" );
      benefits.forEach( function ( benefit ) {
        var benefitFilters = benefit.getAttribute( "data-category" ).split( " " );
        var showBenefit = false;
        activeFilters.forEach( function ( activeFilter ) {
          if (
            benefitFilters.includes( activeFilter.getAttribute( "data-attribute" ) )
          ) {
            showBenefit = true;
          }
        } );
        if ( showBenefit ) {
          benefit.style.display = "block";
        } else {
          benefit.style.display = "none";
        }
      } );
    } );
  } );
} );

let navs = document.querySelectorAll( ".tier-benefits-main .nav-link" );
navs[0].classList.add( "active" );

let tabs = document.querySelectorAll( ".tier-benefits-main .tab-pane" );
tabs[0].classList.add( "active", "show" );
